export function list(data){
        return{
            type: 'TESTEREDUX',
            payload : [data]
        }
}
